var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDropzoneIcon = function SvgDropzoneIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12.5L24.5 14.5C24.5 15.6046 25.3954 16.5 26.5 16.5C27.6046 16.5 28.5 15.6046 28.5 14.5V12.1569C28.5 11.096 28.0786 10.0786 27.3284 9.32843L21.6716 3.67157C20.9214 2.92143 19.904 2.5 18.8431 2.5H6.5C5.39543 2.5 4.5 3.39543 4.5 4.5V28.5C4.5 29.6046 5.39543 30.5 6.5 30.5H12.5C13.6046 30.5 14.5 29.6046 14.5 28.5C14.5 27.3954 13.6046 26.5 12.5 26.5H8.5V6.5H18.5V10.5C18.5 11.6046 19.3954 12.5 20.5 12.5H24.5Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 26.5C18.5 25.3954 19.3954 24.5 20.5 24.5H22.5V22.5C22.5 21.3954 23.3954 20.5 24.5 20.5C25.6046 20.5 26.5 21.3954 26.5 22.5V24.5H28.5C29.6046 24.5 30.5 25.3954 30.5 26.5C30.5 27.6046 29.6046 28.5 28.5 28.5H26.5V30.5C26.5 31.6046 25.6046 32.5 24.5 32.5C23.3954 32.5 22.5 31.6046 22.5 30.5V28.5H20.5C19.3954 28.5 18.5 27.6046 18.5 26.5Z",
    fill: "#868686"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDropzoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DropzoneIcon.38d90e37.svg";
export { ForwardRef as ReactComponent };